import { lazy } from "react";

export default lazy(() => import("./eager"));
export type { WriteProps as MarkdownEditProps } from "./Write";
